import { defineComponent as _defineComponent } from 'vue'
interface Props {
  email: string;
  searchFeed: string;
  id: string | number;
  absolute?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransparencyProgramInfo.ts',
  props: {
    email: null,
    searchFeed: null,
    id: null,
    absolute: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})